var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda;

  return "<div class=\"list-item-icon\">\n    <img class=\"img-circle icon\" src=\""
    + alias1(__default(require("/root/project/webapp/src/common/ui/template/helper/image.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.image_url : depth0),"small",{"name":"image","hash":{},"data":data}))
    + "\" />\n</div>\n<div class=\"list-item-content\">\n    <div class=\"list-item-header group-name\">\n        <div class=\"list-item-header-title\">\n            "
    + alias1(alias2((depth0 != null ? depth0.name : depth0), depth0))
    + "\n        </div>\n        <div class=\"list-item-header-right\">\n            <span class=\"badge owned-nodes\">"
    + alias1(alias2((depth0 != null ? depth0.nodeNum : depth0), depth0))
    + "</span>\n        </div>\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./system/ui/template/owner/item.hbs
// module id = 1185
// module chunks = 0